import { AUDIO_VALUE_MAPS, OPTIONS } from './mvData';

const PRO_AUDIO_MODEL = 'lyria-3-pro-preview';

export function buildLyricsPayload(values) {
  return {
    prompt: values.idea.trim(),
    genre: mapAudioValue('style', values.style),
    mood: mapAudioValue('mood', values.mood),
    vocalType: mapAudioValue('vocal', values.vocal),
    language: mapAudioValue('language', values.language),
  };
}

export function buildMusicPayload(values, lyrics, hasImages = false) {
  const hasLyrics = Boolean(String(lyrics || '').trim());
  return cleanPayload({
    prompt: values.musicPrompt.trim(),
    lyrics: hasLyrics ? lyrics : '',
    lyricsAssistant: !hasLyrics,
    genre: mapAudioValue('style', values.style),
    mood: mapAudioValue('mood', values.musicMood || values.mood),
    vocalType: mapAudioValue('vocal', values.vocal),
    language: mapAudioValue('language', values.language),
    audioModel: PRO_AUDIO_MODEL,
    duration: durationSeconds(values.duration),
    mode: hasImages ? values.musicMode : 'clip',
  });
}

export function buildMusicDraft(record, values, lyricsText) {
  const prompt = values.musicPrompt.trim();
  const style = optionLabel('style', values.style);
  const vocal = optionLabel('vocal', values.vocal);
  const audioUrl = record.audioUrl || record.fileUrl || record.mediaUrl || '';
  const lyricsTimestamp = normalizeLyricsTimestamp(record.lyricsTimestamp);
  return {
    id: record.id,
    title: prompt || `${style} ${vocal}`,
    meta: `${vocal} • ${durationSeconds(values.duration)}s`,
    lyrics: record.lyrics || lyricsText,
    lyricsTimestamp,
    prompt,
    audioUrl,
    downloadUrl: record.downloadUrl || audioUrl,
    coverUrl: record.coverUrl,
  };
}

export function readErrorMessage(error) {
  return error?.response?.data?.error || error?.response?.data?.message ||
    error?.message || 'Generation failed';
}

function mapAudioValue(group, value) {
  return AUDIO_VALUE_MAPS[group]?.[value] || value;
}

function optionLabel(group, value) {
  const options = OPTIONS[group] || [];
  const matched = options.find((item) => {
    return typeof item === 'string' ? item === value : item.value === value;
  });
  if (!matched) return value;
  return typeof matched === 'string' ? matched : matched.label;
}

function durationSeconds(value) {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed)) return 30;
  return Math.min(180, Math.max(30, parsed));
}

function cleanPayload(payload) {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );
}

function normalizeLyricsTimestamp(value) {
  const list = Array.isArray(value) ? value : parseTimestampJson(value);
  return list
    .map((item) => ({
      text: String(item?.text || '').trim(),
      startTimeMs: Number(item?.startTimeMs),
      endTimeMs: Number(item?.endTimeMs),
    }))
    .filter((item) => (
      item.text &&
      Number.isFinite(item.startTimeMs) &&
      Number.isFinite(item.endTimeMs) &&
      item.endTimeMs >= item.startTimeMs
    ))
    .sort((a, b) => a.startTimeMs - b.startTimeMs);
}

function parseTimestampJson(value) {
  if (typeof value !== 'string' || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}
